import React, {useState, useRef, useEffect} from 'react';
import makeStyles from '@mui/styles/makeStyles';
import ImageGallery from 'react-image-gallery';
import {isVideo, renderVideo} from '../util/VideoHelpers';
import {sortById} from '../util/SortingFunctions';
import {theme} from '../Theme';
import 'react-image-gallery/styles/css/image-gallery.css';

const useStyles = (isFullScreen: $TSFixMe) =>
  makeStyles(() => ({
    ImageGallery: {
      padding: isFullScreen ? 0 : 'initial',
      '& .image-gallery-image': {
        height: isFullScreen ? '100vh !important' : '36vh !important',
        width: '100%',
        objectFit: isFullScreen ? 'contain' : 'cover',
        borderRadius: isFullScreen ? 'initial' : 12,
      },
      '& .image-gallery-icon': {
        color: theme.palette.secondary.main,
        filter: 'drop-shadow(0px 0px 0px #242424)',
      },
      '& .image-gallery-svg': {
        height: '100px !important',
      },
      '& .image-gallery-left-nav': {
        paddingLeft: 0,
      },
      '& .image-gallery-right-nav': {
        paddingRight: 0,
      },
      '& .image-gallery-description': {
        top: 8,
        left: 8,
        height: 'fit-content !important',
        bottom: 'auto',
        borderRadius: 6,
        fontSize: 13,
        backgroundColor: theme.palette.primary.main,
        padding: '4px 6px !important',
        marginLeft: '10px !important',
        textTransform: 'uppercase',
        fontFamily: "'AeonikProReqular', sans-serif",
      },
      '& .image-gallery-index': {
        top: 8,
        right: 8,
        borderRadius: 6,
        fontSize: 13,
        backgroundColor: theme.palette.primary.main,
        padding: '4px 6px',
        textTransform: 'uppercase',
        fontFamily: "'AeonikProReqular', sans-serif",
      },
    },
  }));

const BidmiiImageCarousel = (props: $TSFixMe) => {
  const [attachments, setAttachments] = useState(
    props.requestForProposal.attachmentReferences,
  );

  const [isFullScreen, setIsFullScreen] = useState(false);
  const imageRef = useRef(null);
  const classes = useStyles(isFullScreen)();

  useEffect(() => {
    setAttachments(props.requestForProposal.attachmentReferences);
  }, [props.requestForProposal]);

  const getCarousel = () => {
    if (!attachments) {
      return null;
    }

    let images;
    if (!props.stageIndex) {
      images = attachments.filter((ref: $TSFixMe) =>
        ['before_image', 'after_image', 'inspiration'].includes(ref.key),
      );
    } else {
      const attachmentsForStage = attachments.filter(
        (ref: $TSFixMe) =>
          ref.key === 'after_image' &&
          ref.description.includes(props.stageIndex),
      );
      images =
        attachmentsForStage.length === 0
          ? attachments.filter((ref: $TSFixMe) => ref.key === 'after_image')
          : attachmentsForStage;
    }
    if (images.length === 0) {
      return null;
    } else {
      images = images.sort(sortById);
    }

    const items = images.map((img: $TSFixMe, index: $TSFixMe) => {
      const item = {
        original: img.url,
        originalAlt: `${img.name} for ${props.requestForProposal.title}`,
        description: img.description.replace(' image', ''),
      };
      if (isVideo(img.url)) {
        (item as $TSFixMe).renderItem = renderVideo(img, isFullScreen);
      }
      return item;
    });

    return (
      <div className={classes.ImageGallery}>
        <ImageGallery
          ref={imageRef}
          items={items}
          infinite={true}
          showIndex={true}
          // showNav={window.innerWidth > 600}
          showThumbnails={false}
          showPlayButton={false}
          showFullscreenButton={false}
          onScreenChange={(bool) => setIsFullScreen(bool)}
          onClick={() => {
            try {
              // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
              imageRef.current.fullScreen();
            } catch (e) {
              // eslint-disable-next-line no-alert
              alert('Sorry, something went wrong');
            }
          }}
        />
      </div>
    );
  };

  return getCarousel();
};

export default BidmiiImageCarousel;
